import createReactComponent from '../createReactComponent';
export default createReactComponent('gender-agender', 'IconGenderAgender', [
  ['path', { d: 'M12 12m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0', key: 'svg-0' }],
  ['path', { d: 'M7 12h11', key: 'svg-1' }],
]);
